import { locale as avatarInitials } from '@users/components/avatar-initials/i18n/en';

export const locale = {
    lang: 'en',
    data: {
        ...avatarInitials.data
    }
};